<template>
  <div class="container">

    <el-row style="margin-bottom:20px">
        <el-breadcrumb separator-class="el-icon-arrow-right">
        <el-breadcrumb-item :to="{ path: '/' }">首页</el-breadcrumb-item>
        <el-breadcrumb-item :to="{ path: '/director-work' }">工作台</el-breadcrumb-item>
        <el-breadcrumb-item :to="{ path: '/director-workmaster-clock' }">打卡</el-breadcrumb-item>
        <el-breadcrumb-item >设置打卡</el-breadcrumb-item>
      </el-breadcrumb>
    </el-row>

    <div class="cont">
      <el-form ref="form" :model="formData"   label-width="130px" :rules="rules">

        <el-form-item label="考勤名称" prop="title" >  
          <el-input v-model="formData.title" placeholder="考勤名称"></el-input>
       </el-form-item>

       <el-form-item label="项目名称" prop="project_id"  >  
        <el-select v-model="formData.project_id" placeholder="请选择" @change="selectProject">
          <el-option
            v-for="item in projectDataList"
            :key="item.project_id"
            :label="item.name"
            :value="item.project_id">
          </el-option>
        </el-select>
       </el-form-item>

       <el-form-item label="职位名称" prop="job_id">
        <el-select v-model="formData.job_id" placeholder="请选择" clearable filterable>
          <el-option
            v-for="item in jobDataList"
            :key="Number(item.job_id)"
            :label="item.title"
            :value="Number(item.job_id)">
          </el-option>
        </el-select>
       </el-form-item>


        <el-form-item label="打卡类型" prop="type">
          <el-radio-group v-model="formData.type">

            <el-radio
            v-for="item in clock_types"
            :key="item.value"
            :label="item.value">{{item.name}}
          </el-radio>

          </el-radio-group>
        </el-form-item>

       <el-form-item label="添加打卡范围" prop="mi" >
         <el-select v-model="formData.mi" placeholder="请选择">
          
           <el-option
            v-for="item in clock_mis"
              :key="item.value"
              :label="item.name"
              :value="item.value">
          </el-option>

         </el-select>
       </el-form-item>

       <el-form-item label="打卡时间" prop="days" >
        <el-checkbox-group v-model="formData.days">
          <el-checkbox label="周一" key="1">周一</el-checkbox>
          <el-checkbox label="周二" key="2">周二</el-checkbox>
          <el-checkbox label="周三" key="3">周三</el-checkbox>
          <el-checkbox label="周四" key="4">周四</el-checkbox>
          <el-checkbox label="周五" key="5">周五</el-checkbox>
          <el-checkbox label="周六" key="6">周六</el-checkbox>
          <el-checkbox label="周日" key="7">周日</el-checkbox>

        </el-checkbox-group>
       </el-form-item>

       <el-form-item label="打卡时间" prop="clock_time" >
          <el-time-picker
          format="HH:mm"   value-format="HH:mm"
            v-model="formData.clock_start_time"
            @change="setTime1"
            placeholder="打卡开始时间">
          </el-time-picker>
          -
          <el-time-picker
          format="HH:mm"   
          value-format="HH:mm"
          @change="setTime2"
            v-model="formData.clock_end_time"
            placeholder="打卡结束时间">
          </el-time-picker>
       </el-form-item>
  
       <el-form-item label="打卡地址" prop="address">
                <el-button type="primary" plain @click="selectAddress">添加地址</el-button>
        </el-form-item>


        <el-form-item label="" >
            <el-table :data="formData.address" style="width: 100%" >
              <el-table-column fixed  prop="shop_name" label="店铺"></el-table-column>
              <el-table-column fixed  prop="address" label="地址" ></el-table-column>

              <el-table-column fixed  prop="adname" label="详细地址" ></el-table-column>
              <el-table-column  label="操作">
                <template slot-scope="scope">
                  <el-button
                    @click.native.prevent="deleteRow(scope.$index, formData.address)"  type="text"  size="small">
                    移除
                  </el-button>
                </template>
              </el-table-column>
            </el-table>
         </el-form-item>

       <el-form-item label="范围外打卡" prop="link">
          <el-radio-group v-model="formData.link">
            <el-radio  :label="1">允许</el-radio>
            <el-radio :label="2">不允许</el-radio>
          </el-radio-group>
        </el-form-item>

        <el-form-item label="是否允许补卡" prop="mend">
          <el-radio-group v-model="formData.mend">
            <el-radio  :label="1">允许</el-radio>
            <el-radio :label="2">不允许</el-radio>
          </el-radio-group>
        </el-form-item>

        <el-form-item label="每月最多补卡" prop="mend_num">
          <el-select v-model="formData.mend_num" placeholder="请选择" clearable filterable>
          <el-option
            v-for="item in mend_nums"
            :key="item.value"
            :label="item.name"
            :value="item.value">
          </el-option>
        </el-select>
       </el-form-item>


       <el-form-item label="允许补卡时限" prop="mend_day">
          <el-select v-model="formData.mend_day" placeholder="请选择" clearable filterable>
          <el-option
            v-for="item in mend_days"
            :key="item.value"
            :label="item.name"
            :value="item.value">
          </el-option>
        </el-select>
       </el-form-item>

       

        <el-form-item>
          <el-button type="primary" @click="onSubmit">确定</el-button>
          <el-button @click="back">取消</el-button>
        </el-form-item>
     </el-form>
    </div>

    <address-select-dialog ref="selectAddressDialog" @setAddress="setAddress"></address-select-dialog>
  </div>
</template>

<script>
import { addClockSet,updateClockSet,clockSetInfo} from "@/api/director/clock/index.js";
import { projectList} from "@/api/director/project/index.js";
import { jobList} from "@/api/director/job/index.js";

import addressSelectDialog from "@/components/address/address-select-dialog.vue";

export default {
  components: {
    addressSelectDialog
  },
    name: "Director-Work-CLock",
    data() {
      return {
        id:"",
        clock_types:[
          {
            value:1,
            name:'固定上下班'
          },
          {
            value:2,
            name:'自由上下班'
          }
        ],

        clock_mis:[
          {
            value:20,
            name:'20米'
          },
          {
            value:50,
            name:'50米'
          }, {
            value:100,
            name:'100米'
          },
          {
            value:200,
            name:'200米'
          }
        ],

        mend_nums:[
       
        {
            value:-1,
            name:'不限制'
          },
          
          {
            value:1,
            name:'1次'
          }, {
            value:2,
            name:'2次'
          },
          {
            value:3,
            name:'3次'
          },
          {
            value:4,
            name:'4次'
          },

          {
            value:5,
            name:'5次'
          }
        ],

        mend_days:[
       
          {
            value:-1,
            name:'不限制'
          },
          {
            value:1,
            name:'1天'
          }, {
            value:2,
            name:'2天'
          },
          {
            value:3,
            name:'3天'
          },
          {
            value:4,
            name:'4天'
          },

          {
            value:5,
            name:'5天'
          }
        ],


        rules: {

          
          title: [
                {required: true, message: '请输入考勤名称', trigger: 'blur'}
           ],
          job_id: [
                {required: true, message: '请选择职位', trigger: 'change'}
            ],
            project_id: [
                {required: true, message: '请选择项目', trigger: 'change'}
            ],
            
            type: [
                {required: true, message: '请选择打卡类型', trigger: 'change'}
            ],

            days: [
                {required: true, message: '请选择打卡日期', trigger: 'change'}
            ],

            address: [
                {required: true, message: '请选择打卡地址', trigger: 'change'}
            ],

            clock_time: [
                {required: true, message: '请选择打卡时间', trigger: 'change'}
            ],
            link: [
                {required: true, message: '请设置是否打卡外范围', trigger: 'change'}
            ],
            mi: [
                {required: true, message: '请选择打卡范围', trigger: 'change'}
            ],
            mend: [
                {required: true, message: '请选择是否允许补卡', trigger: 'change'}
            ],
            mend_num: [
                {required: true, message: '请设置补卡次数', trigger: 'change'}
            ],
            mend_day: [
                {required: true, message: '请设置补卡天数', trigger: 'change'}
            ]
       },

        formData:{
          id:"",
          project_id:"",
          job_id:"",//职位id
          type:"",//打卡类型，1固定上下班，2自由上下班
          title:"",//考勤名称
          days:[],//打卡时间
          clock_start_time:"",
          clock_end_time:"",
          clock_time:"",//打卡开始结束时间

          link:null,//是否允许范围外打卡，1允许，2不允许
          mi:"",//打卡范围米数

          mend:null,//是否允许补卡，1是，2否
          mend_num:null,
          mend_day:null,
          address:[],
          user_app_ids:[]

        },

        addressObj:{},
        projectDataList:[],
        jobDataList:[],
        addressDataList:[]

      }
    },

    mounted() {
      this.id= this.$route.query.id;
      if(this.id){
        this.initData();
      }
      if(this.$route.query.project_id){
        this.formData.project_id=parseInt(this.$route.query.project_id);
      }
      this.initProjectList();
      this.initJobList();
     
    },

    methods: {

    initData(){
      var that=this;
      clockSetInfo({id:that.id}).then((response) => {
          console.log(response);
          if(response.code==200){
            that.formData=response.data;

            // that.formData.clock_start_time= that.formData.clock_time.split('-')[0];
            // that.formData.clock_end_time= that.formData.clock_time.split('-')[1];
            // that.formData.clock_id=that.clock_id;

            delete that.formData.created_at;
            delete that.formData.updated_at;
            delete that.formData.user_app_ids;

          }else{
            this.$message({
              message: response.msg?response.msg:"获取信息失败",
            });
          }
        });
    },
       //项目列表
    initProjectList(){
      var that = this;
      projectList({}).then((response) => {
        console.log('projectList',response);
        that.projectDataList = response.data;

      });
    },

    selectProject(e){
      this.formData.project_id=e;
      this.formData.job_id=""
      this.initJobList();
    },
    

    //职位列表
    initJobList(){
      var that = this;
      jobList({
        project_id:this.formData.project_id
      }).then((response) => {
        console.log('jobList',response);
        that.jobDataList = response.data;
      });
    },


    selectAddress(){
      this.$refs.selectAddressDialog.init(this.formData.address);
    },

    setAddress(addressList){
      this.formData.address=addressList;
    },
    deleteRow(index, rows) {
        rows.splice(index, 1);
    },

    setTime1(e){
      var that=this;
      if(that.formData.clock_start_time&&that.formData.clock_end_time){
        that.formData.clock_time= that.formData.clock_start_time+'-'+that.formData.clock_end_time;
      }
    },

    setTime2(e){
      var that=this;
      if(that.formData.clock_start_time&&that.formData.clock_end_time){
        that.formData.clock_time= that.formData.clock_start_time+'-'+that.formData.clock_end_time;
      }
     
    } ,


    onSubmit(){
        var that=this;
        that.formData.clock_time= that.formData.clock_start_time+'-'+that.formData.clock_end_time;

        this.$refs["form"].validate((valid) => {
            if (valid) {
              if(that.id){
                updateClockSet(that.formData).then((response) => {
                      console.log(response);
                      if(response.code==200){
                        this.$message({
                          message: "提交成功",
                          type: 'success'

                        });
                       //that.$emit('refresh');
                       // that.visible = false;

                      this.$router.go(-1)
                       //this.$router.push({ name: "director-workmaster-clock" });

                      }else{
                        this.$message({
                          message: response.msg?response.msg:"提交失败",
                        });
                      }
                  });
              }else{
                addClockSet(that.formData).then((response) => {
                      console.log(response);
                      if(response.code==200){
                        this.$message({
                          message: "提交成功",
                          type: 'success'

                        });
                        that.$router.go(-1)
                        //that.$router.push({ name: "director-workmaster-clock" });

                      
                      }else{
                        this.$message({
                          message: response.msg?response.msg:"提交失败",
                        });
                      }
                });
              }
            } 
          });
      },
      back(){
        this.$router.go(-1);
      }
      
    }
  }
</script>
<style lang="scss" scoped>
::v-deep .main_box{
  background: #EEEBEC !important; 
}
.head{
  display: flex;
  justify-content: flex-start;
  background: #ffffff;
  box-shadow: 0px 0px 13px rgba(0,0,0,0.15);
  img{
    width: 120px;
    height: 120px;
    margin-right: 20px;
  }
  .title{
    margin-top: 20px;
    font-weight: bold;
    font-size: 20px;
  }
  .desc{
    margin-top: 10px;

  }
}

.cont{
  padding: 20px;
  box-shadow: 0px 0px 13px rgba(0,0,0,0.15);
  margin-top: 20px;

  .clock-list{
    display: flex;
    justify-content: space-between;
    margin-top: 10px;
    flex-flow: wrap;
 
    .unit{
      display: flex;
      justify-content: space-between;
      background: #F6F6F6;
      align-items: center;
      padding: 10px 30px;
      min-width: calc((100% - 160px) / 2);
      max-width: calc((100% - 160px) / 2);
      flex: 1;
      margin-bottom: 20px;

      .job{
        max-width: 300px;
        text-overflow: ellipsis;
        overflow: hidden;
        white-space: nowrap;
      }

      .op{
        display:flex;
        align-items: center;
      }
      .btns{
        display: flex;
        justify-content: flex-end;
        align-items: center;
        margin-left: 20px;
        span{
          line-height: 30px;
          text-align: center;
          border-radius: 4px;
          color: #4c71db;
          border: none;
          margin-left: 20px;
          background: none;
        }
      }
    }
  }


  .edit-list{
    display: flex;
    justify-content: space-between;
    margin-top: 10px;
    flex-flow: wrap;
 
    .unit{
      background: #F6F6F6;
      padding: 10px 30px;
      min-width: calc((100% - 160px) / 2);
      max-width: calc((100% - 160px) / 2);
      flex: 1;
      margin-bottom: 20px;

      .title{
        text-align: center;
      }

      .desc{
        text-align: center;
      }

      .btns{
        text-align: center;
        align-items: center;
        margin-left: 20px;
        span{
          line-height: 30px;
          text-align: center;
          border-radius: 4px;
          color: #4c71db;
          border: none;
          margin-left: 20px;
          background: none;
        }
      }
      


    }
  }
}
</style>